import { authStore } from "../../stores/General";
import { createAuthUser } from "./user";
import { getClient } from "./client";
import { logout } from "./logout";


export async function loginWithPopup(options) {
  const client = await getClient();
  try {
    await client.loginWithPopup(options);

    const usd = await client.getUser();

    //localStorage.setItem("isAuthenticated",true)

    localStorage.setItem("token", await client.getTokenSilently());

    // await sendPostRequest("/user");

    let userInfo = {
      first_name: usd.given_name,
      last_name: usd.family_name,
      email: usd.email,
      phone_number: usd.phone_number,
      country: usd.country,
      picture: usd.picture,
      auth_type: usd.sub,
    };

    await createAuthUser(userInfo);
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
  }
}

export const checkAuth = async (onCatch) => {
  let client = await getClient();
  let token = await localStorage.getItem("token");

  try {
    // if (window.Cypress) {
    //   const auth0 = JSON.parse(localStorage.getItem("auth0Cypress"));
    //   authStore.user.set(auth0.body.decodedToken.user);
    //   authStore.isAuthenticated.set(true);
    // } else 
    if (!token) {
      logout({
        returnTo: window.location.origin + "/login",
      });
      return;
    } else {
      localStorage.setItem("token", await client.getTokenSilently());

      const usd = await client.getUser();

      let userInfo = {
        first_name: usd.given_name,
        last_name: usd.family_name,
        email: usd.email,
        phone_number: usd.phone_number,
        country: usd.country,
        picture: usd.picture,
        auth_type: usd.sub,
      };

      await createAuthUser(userInfo);

      // authStore.user.set(await client.getUser());
      // authStore.isAuthenticated.set(await client.isAuthenticated());
    }
  } catch (e) {
    authStore.isAuthenticated.set(false);
    onCatch && onCatch(e);
    return false;
  }
};

